import React, { useEffect, useState } from 'react';
import api from '../../services/api';
import Table from '../../components/Table';

function Protocols() {
  const [protocols, setProtocols] = useState([]);
  const [openProgress, setOpenProgress] = useState(false);
  const columns = [
    {
      title: 'Nome',
      field: 'name',
      hideFilterIcon: true,
    },
    {
      title: 'Parametros',
      field: 'rules',
      render: (rowData) => {
        let parameters = '';
        rowData.rules.map((rule) => parameters += (`${rule.parameter.name}, `));
        return (
          parameters.slice(0, -2)
        );
      },
      hideFilterIcon: true,
    },
  ];

  useEffect(() => {
    async function loadData() {
      try {
        const response = await api.get('/protocols');

        if (response.data.length === 0) {
          setOpenProgress(true);
        }
        if (response.data) {
          response.data.map(async (protocol) => {
            const p = await api.get(`/protocols/${protocol.id}`);
            protocol.parameters = p.data.rules;
            /* let parameters = "";
                        p.data.rules.map(r => parameters +=r.parameter_name+"," );
                        parameters= parameters.slice(0, parameters.length-1);
                        console.log(parameters);
                        console.log(response.data) */
          });

          setProtocols(response.data);
          setOpenProgress(true);
        }
      } catch (err) {
        console.log(err);
      }
    }
    loadData();
  }, []);

  function setData(newData) {
    const tempData = [];
    protocols.map((protocol) => (
      protocol.id === newData.id ? tempData.push(newData) : tempData.push(protocol)
    ));
    alert(JSON.stringify(tempData));
    setProtocols(tempData);
  }
  return (
    <Table title="Protocolos" route="/protocols/" routeAdd="/protocol/" columns={columns} data={protocols} setData={setData} dataLoaded={openProgress} />
  );
}

export default Protocols;
